_ = require 'underscore'

module.exports = (getKey, colls...) ->
  collection = {}
  _.flatten(colls).forEach (x) ->
    key = getKey(x)
    if collection[key] && _.isObject(collection[key])
      collection[key] = _.extend({}, collection[key], x)
    else
      collection[key] = x
  return (value for own key, value of collection)



// WEBPACK FOOTER //
// ./app/scripts/lib/util/value-union.coffee